import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { detect } from 'detect-browser';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnauthorizedGuard  {
  constructor(private router: Router, private route: ActivatedRoute) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const browser = detect();
    const isMobile =
      browser.os === 'iOS' ||
      browser.os === 'Android OS' ||
      browser.os === 'BlackBerry OS' ||
      browser.os === 'Windows Mobile' ||
      browser.os === 'Amazon OS';

    if (!localStorage.token) {
      if (isMobile) {
        this.router.navigate([next.params.lang, 'mobile', 'login'], {
          queryParams: next.queryParams,
          relativeTo: this.route,
        });
      } else {
        this.router.navigate([next.params.lang, 'auth'], {
          queryParams: next.queryParams,
          relativeTo: this.route,
        });
      }
      return false;
    } else {
      return true;
    }
  }
}
